import "angular";
import "angular-resource";
import "angular-ui-bootstrap";
import "angular-cookies";
import "ng-idle";
import AccountDetailsController from "../accountDetails/AccountDetailsController";
import AccountServiceModule from "../accountServiceModule/AccountServiceModule";
import AdviceServiceModule from "../adviceServiceModule/AdviceServiceModule";
import AuthenticationStatusService from "../authentication/AuthenticationStatusService";
import MenuNavigationFactory from "./service/factory/MenuNavigationFactory";
import MenuItemModalService from "./service/MenuItemModalService";
import KeepaliveController from "./keepalive/KeepaliveController";
import KeepaliveConfig from "./keepalive/KeepaliveConfig";
import ActivityFactory from "./keepalive/ActivityFactory";
import UibDatepickerConfig from "./UibDatepickerConfig";
import UibDatepickerPopupConfig from "./UibDatepickerPopupConfig";
import FormatTelFilter from "../filters/FormatTelFilter";
import DocsModule from "../docs/DocsModule";
import EventBusModule from "../eventbus/EventBusModule";
import ContactModalModule from "../ContactModal/ContactModalModule";
import ImgSrcOnError from "../directive/ImgSrcOnError";
import SamlSsoModule from "../Sso/SamlSsoModule";
import ShowMoreOrLessModule from "../directive/showmoreorless/ShowMoreOrLessModule";
import TransactionMessagesModule from "../directive/transactionmessages/TransactionMessagesModule";
import PrimaryPlanTxnAccessSvc from "../layout/service/primaryPlanTxnAccessService";
import MessagingFactory from "../messaging/MessagingFactory";
import HeaderPlanMessagingDelegate from "../service/delegate/HeaderPlanMessagingDelegate";
import DnpInterstitialDirective from "../Sso/token/DnpInterstitialDirective";
import SamlTokenModule from "../Sso/token/SamlTokenModule";

import AcctsCustomizationRetrievalService from "./service/AcctsCustomizationRetrievalService";
import AccuCodeService from "./service/AccuCodeService";
import DefaultAcctsCustRetrievalService from "./service/DefaultAcctsCustRetrievalService";

// Main
import DefaultPlanResourcesService from "./service/DefaultPlanResourcesService";
import FooterFactory from "./service/factory/FooterFactory.js";
import HeaderFactory from "./service/factory/HeaderFactory.js";
import LanguageCodeFactory from "./service/factory/LanguageCodeFactory.js";
import LegacyService from "./service/LegacyService";
import LogoutService from "./service/LogoutService";
import MenuService from "./service/MenuService";
import MobileMenuService from "./service/MobileMenuService";
import PreventNavigationService from "./service/PreventNavigationService";
import TransactionAccessMockService from "./service/TransactionAccessMockService";
import TransactionAccessRetrService from "./service/TransactionAccessRetrService";
import FooterController from "./view/footer/FooterController.js";
import FooterDirective from "./view/footer/FooterDirective.js";
import HeaderController from "./view/header/HeaderController.js";
import HeaderDirective from "./view/header/HeaderDirective.js";
import SaveChangesController from "./view/header/saveChanges/saveChangesController";
import NavMenuDirective from "./view/navMenu/NavMenuDirective";

var moduleName = "LayoutModule";
var moduleDependencies = [
    "ngResource",
    "ui.bootstrap",
    "ngIdle",
    "ngCookies",
    "ngSanitize",
    ImgSrcOnError.name,
    FormatTelFilter.name,
    DocsModule.name,
    AccountServiceModule.name,
    EventBusModule.name,
    AdviceServiceModule.name,
    ContactModalModule.name,
    SamlSsoModule.name,
    SamlTokenModule.name,
    ShowMoreOrLessModule.name,
    TransactionMessagesModule.name
];

const LayoutModule = angular
    .module(moduleName, moduleDependencies)
    .factory("TransactionAccessRetrService", TransactionAccessRetrService)
    .factory("PrimaryPlanTxnAccessSvc", PrimaryPlanTxnAccessSvc)
    .factory("AuthenticationStatusService", AuthenticationStatusService)
    .factory("LogoutService", LogoutService)
    .factory("AcctsCustomizationRetrievalService", AcctsCustomizationRetrievalService)
    .factory("DefaultAcctsCustRetrievalService", DefaultAcctsCustRetrievalService)
    .service("DefaultPlanResourcesService", DefaultPlanResourcesService)

    .factory("FooterFactory", FooterFactory)
    .factory("MenuNavigationFactory", MenuNavigationFactory)
    .factory("LanguageCodeFactory", LanguageCodeFactory)
    .service("MenuService", MenuService)
    .service("MobileMenuService", MobileMenuService)
    .service("MenuItemModalService", MenuItemModalService)
    .service("LegacyService", LegacyService)
    .service("AccuCodeService", AccuCodeService)
    .service("PreventNavigationService", PreventNavigationService)
    .service("TransactionAccessMockService", TransactionAccessMockService)

    .controller("HeaderController", HeaderController)
    .factory("HeaderFactory", HeaderFactory)
    .directive("siteHeader", HeaderDirective)
    .directive("navMenu", NavMenuDirective)
    .controller("AccountDetailsController", AccountDetailsController)
    .controller("FooterController", FooterController)
    .directive("siteFooter", FooterDirective)
    .directive("dnpInterstitialDirective", DnpInterstitialDirective)
    .controller("KeepaliveController", KeepaliveController)
    .config(KeepaliveConfig)
    .config(UibDatepickerConfig)
    .config(UibDatepickerPopupConfig)
    .factory("ActivityFactory", ActivityFactory)
    .factory("headerPlanMessagingDelegate", HeaderPlanMessagingDelegate)
    .factory("MessagingFactory", MessagingFactory)
    .controller("saveChangesController", SaveChangesController);

export default LayoutModule;
